import {useState, useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {useAppSelector, useAppDispatch} from '../../../../../store/hooks.ts'
import {selectOpenDropdownId} from '../../../../../store/ui/uiSelectors.ts'
import {selectAuth} from '../../../../../store/auth/authSelectors.ts'
import {setOpenDropdown, setOpenModal} from '../../../../../store/ui/uiSlice.ts'
import {logoutSaga} from '../../../../../store/auth/authSlice.ts'
import SidebarUiButton from '../SidebarUiButton/SidebarUiButton.tsx'
import Avatar from '../../../../ui/Avatar/Avatar.tsx'
import DropdownWrapper from '@/components/ui/Dropdown/components/DropdownWrapper/DropdownWrapper.tsx'
import Dropdown from '../../../../ui/Dropdown/Dropdown.tsx'
import DropdownItem from '@/components/ui/Dropdown/components/DropdownItem/DropdownItem.tsx'
import DropdownDivider from '@/components/ui/Dropdown/components/DropdownDivider/DropdownDivider.tsx'
import IconLogo from '@/assets/icons/icon-logo.svg?react'
import IconChevron from '@/assets/icons/icon-arrow-down.svg?react'
import css from './SidebarAuthButton.module.css'

const DROPDOWN_ID = 'sidebar-auth-button'

const SidebarAuthButton = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const openDropdownId = useAppSelector(selectOpenDropdownId)
    const auth = useAppSelector(selectAuth)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    useEffect(() => {
        const shouldBeOpen = openDropdownId === DROPDOWN_ID
        if (isDropdownOpen !== shouldBeOpen) {
            setIsDropdownOpen(shouldBeOpen)
        }
    }, [openDropdownId, isDropdownOpen])

    const handleAvatarClick = () => {
        dispatch(setOpenDropdown(isDropdownOpen ? null : DROPDOWN_ID))
    }

    const handleClose = () => {
        dispatch(setOpenDropdown(null))
    }

    const handleAccount = () => {
        dispatch(setOpenModal({type: 'accountSettings'}))
        dispatch(setOpenDropdown(null))
    }

    const handleSignIn = () => {
        navigate('/auth')
        dispatch(setOpenDropdown(null))
    }

    const handleWhatsNew = () => {
        window.location.href = `${window.location.origin}/docs/changelog/`
    }

    const handleDocs = () => {
        window.location.href = `${window.location.origin}/docs`
    }

    const handleOnClick = () => {
        window.location.href = `${window.location.origin}/about`
    }

    const handleSignOut = () => {
        dispatch(logoutSaga())
        dispatch(setOpenDropdown(null))
    }

    if (auth === null) {
        return (
            <DropdownWrapper>
                <div className={css.logo} onClick={handleAvatarClick}>
                    <IconLogo/>
                </div>
                <Dropdown isOpen={isDropdownOpen} onClose={handleClose} direction="up">
                    <DropdownItem title="What's new" onClick={handleWhatsNew}/>
                    <DropdownItem title="Docs" onClick={handleDocs}/>
                    <DropdownItem title="Help" onClick={handleOnClick}/>
                    <DropdownItem title="Sign in" muted={true} onClick={handleSignIn}/>
                </Dropdown>
            </DropdownWrapper>
        )
    }

    return (
        <DropdownWrapper>
            <SidebarUiButton
                icon={<Avatar title={auth?.username || ''} avatar={auth?.avatarImage} color={auth?.color || 'gray'}
                              size={"medium"}/>}
                title={auth?.username || ''}
                rightIcon={<IconChevron />}
                onClick={handleAvatarClick}
                testId="sidebar-auth-btn"
            />
            <Dropdown isOpen={isDropdownOpen} onClose={handleClose} direction="up">
                <DropdownItem title={auth?.username || ''} highlight={true}/>
                <DropdownItem title="My account" onClick={handleAccount} testId="my-account-btn"/>
                <DropdownDivider/>
                <DropdownItem title="What's new" onClick={handleWhatsNew}/>
                <DropdownItem title="Docs" onClick={handleDocs}/>
                <DropdownItem title="Help" onClick={handleOnClick}/>
                <DropdownItem muted title="Sign out" onClick={handleSignOut} testId="sign-out-btn"/>
            </Dropdown>
        </DropdownWrapper>
    )
}

export default SidebarAuthButton
